import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/KineticMarquee";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="relative bg-[#050505] text-[#F5F5F0] overflow-x-hidden">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <About />
      <Process />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
